export default __webpack_public_path__ + "static/media/selectedTile.cf127abd.svg";